'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmBack, IconLlmGenerate, IconLlmIdea } from '@websolutespa/bom-mixer-icons';
import { LlmAction } from '../../../types';
import { LlmChunkWrapper, useActions } from '../../../useLlm/useActions';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import style from './page-actions.module.scss';

export const PageActions: React.FC<{ wrapper: LlmChunkWrapper }> = ({ wrapper }) => {
  const label = useLabel();
  const streaming = useLlm(state => state.streaming);
  const { clear } = useLlm(state => state.actions);
  const { send } = useLlmView(state => state.actions);
  const { setWrapper } = useActions();
  const onAction = async (action: LlmAction) => {
    const prompt = action.message || action.label;
    clear();
    await send(prompt, (response) => {
      // console.log('PageActions.onChunk', response.chunks);
    }, (response) => {
      // console.log('PageActions.onEnd', response);
    });
  };
  return (wrapper.actions.length > 0) && (
    <div className={getClassNames(style.actions, '-actions')}>
      <button className={getClassNames(style.back)} type="button"
        aria-label={label('llm.back')}
        onClick={() => setWrapper(null)}
      >
        <IconLlmBack />
      </button>
      {wrapper.actions.map(x => (
        <button key={x.id} type="button" className={getClassNames(style.action)}
          disabled={streaming}
          onClick={(e) => {
            e.stopPropagation();
            onAction(x);
          }}>
          <ActionIcon action={x} />
          <span>{x.label}</span>
        </button>
      ))}
    </div>
  );
};

function ActionIcon({ action }: { action: LlmAction }) {
  const icon = action.icon || action.type || 'idea';
  switch (icon) {
    case 'generate':
      return <IconLlmGenerate />;
    case 'idea':
      return <IconLlmIdea />;
    default:
      return <IconLlmIdea />;
  }
}
